import React, { useEffect, useState } from "react";
import {
  AIRTABLE_URL,
  AIRTABLE_URL_TECHNICIAN,
  AIRTABLE_HEADERS,
} from "../constants";

export default function TechnicianRatings() {
  const [technicians, setTechnicians] = useState([]);
  const [ratings, setRatings] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [techRes, ratingRes] = await Promise.all([
        fetch(AIRTABLE_URL_TECHNICIAN, { headers: AIRTABLE_HEADERS }),
        fetch(AIRTABLE_URL, { headers: AIRTABLE_HEADERS }),
      ]);

      const techData = await techRes.json();
      const ratingData = await ratingRes.json();

      setTechnicians(techData.records);
      setRatings(ratingData.records);
    } catch (err) {
      console.error("Error fetching data", err);
    }
  };

  const getTechnicianName = (phone) => {
    const tech = technicians.find(
      (t) => t.fields.phone?.toString().trim() === phone?.toString().trim()
    );
    return tech?.fields.name || "Unknown";
  };

  const getRatingsByPhone = (phone) => {
    return ratings.filter(
      (r) =>
        r.fields.assignedTechnicianPhone?.toString().trim() ===
        phone?.toString().trim()
    );
  };

 const calculateAverageRating = (feedbackList) => {
  const validRatings = feedbackList
    .map(r => parseFloat(r.fields.rating?.toString().trim()))
    .filter(r => !isNaN(r)); // only keep numbers

  if (validRatings.length === 0) return 0;

  const total = validRatings.reduce((sum, r) => sum + r, 0);
  return total / validRatings.length;
};

  // Get unique phones that actually have ratings
  const technicianPhonesWithRatings = [
    ...new Set(
      ratings
        .map((r) => r.fields.assignedTechnicianPhone)
        .filter(Boolean)
    ),
  ];

  // Map to technician data, only include those with at least one rating
  const technicianData = technicianPhonesWithRatings
    .map((phone) => {
      const feedbackList = getRatingsByPhone(phone);
      if (feedbackList.length === 0) return null; // skip if no ratings
      const avgRating = calculateAverageRating(feedbackList);
      const techName = getTechnicianName(phone);
      return { phone, techName, avgRating };
    })
    .filter(Boolean); // remove nulls

  // Sort by average rating - highest to lowest
  const sortedTechnicians = technicianData.sort((a, b) => b.avgRating - a.avgRating);

  return (
    <div style={{ padding: 20 }}>
      <h2>⭐ Technician Ratings</h2>

      {sortedTechnicians.length === 0 ? (
        <p>No ratings available yet.</p>
      ) : (
        sortedTechnicians.map(({ phone, techName, avgRating }) => (
          <div
            key={phone}
            style={{
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: 15,
              marginBottom: 15,
              background: "#f7f7f7",
            }}
          >
            <p><b>Name:</b> {techName}</p>
            <p><b>Phone:</b> {phone}</p>
            <p><b>Average Rating:</b> {avgRating.toFixed(2)} ⭐</p>
          </div>
        ))
      )}
    </div>
  );
}
